module.exports = __webpack_public_path__ + "static/media/mpl-footer.a4f24f84.jpg";